<ng-container *transloco="let t">
  <div class="flex flex-wrap items-center gap-3">
    <button
      [iDropdownMenuTrigger]="catMenu"
      variant="ghost"
      iButton
      placement="bottom"
      class="text-muted-foreground border border-dashed"
    >
      <IIcon name="filter" />

      {{ t("common.filter") }}
    </button>

    <ng-template #catMenu>
      <IDropdownMenu class="w-[200px]">
        @for (filterCategory of availableFiltersByCategory(); track filterCategory.category) {
          @if (filterCategory.category !== "") {
            <div class="px-2 py-0.5">
              <span class="text-xs tracking-tight text-gray-500">{{ filterCategory.category }}</span>
            </div>
          }
          @for (filter of filterCategory.filters; track filter.id) {
            <button iDropdownMenuItem (click)="addFilter(filter)">
              @if (filter.icon) {
                <span [class]="filter.icon"></span>
              }
              {{ filter.label }}
            </button>
          } @empty {
            <div class="px-2 py-1.5 text-sm font-medium tracking-tight text-gray-500">
              {{ t("iselect-menu.no_option_available") }}
            </div>
          }
        } @empty {
          <div class="px-2 py-1.5 text-sm font-medium tracking-tight text-gray-500">
            {{ t("iselect-menu.no_option_available") }}
          </div>
        }
      </IDropdownMenu>
    </ng-template>

    @for (filter of selectedFiltersQuery(); track filter.id) {
      <IMultiSelectMenu
        [withSelectOnly]="true"
        [value]="filter.values"
        (valueChange)="onFilterValueChange(filter, $event)"
        [openOnInit]="filter.beingAdded ?? false"
        (closed)="menuClosed(filter)"
        forceOneSelection
        popoverWidth="280"
        [searchQuery]="filter.searchable ? queryFilter() : undefined"
        (searchQueryChange)="queryFilter.set($event!)"
      >
        <ISelectTrigger>
          <ISelectValue [placeholder]="filter.placeholder">
            <div *iSelectValue="let value" class="flex items-center gap-2">
              <button
                iButton
                variant="ghost"
                size="xs"
                class="p-0 text-gray-500 hover:bg-gray-200"
                [iTooltip]="t('filter-tags.clear_filter')"
                iTooltipPlacement="top-center"
                (click)="removeFilter(filter)"
              >
                <IIcon name="close" />
              </button>
              @if (filter.exclude) {
                <span class="text-red-500 uppercase">{{ t("filter-tags.not") }}</span>
              }
              <span class="font-normal text-gray-400">{{ filter.label }}</span>
              <ng-container
                [ngTemplateOutlet]="formatter"
                [ngTemplateOutletContext]="{ $implicit: value, filter: filter }"
              ></ng-container>
            </div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          @if (filter.excludeModeAllowed) {
            <div class="sticky top-0 z-10 bg-white">
              <ISwitchButton
                [options]="[false, true]"
                [buttonTexts]="['filter-tags.include', 'filter-tags.exclude']"
                [buttonTooltips]="['', '']"
                [selected]="filter.exclude ?? false"
                (buttonClicked)="onFilterValueChange(filter, filter.values, $event)"
              />
              <IDropdownMenuSeparator />
            </div>
          }
          @if (filter.filteredOptions && filter.filteredOptions.length > 0 && filter.selectAllOption) {
            <ISelectOption [selectAllOption]="true" />
            <IDropdownMenuSeparator />
          }
          @for (opt of filter.filteredOptions; track opt) {
            <ISelectOption [value]="opt">
              <ng-container
                [ngTemplateOutlet]="formatter"
                [ngTemplateOutletContext]="{ $implicit: [opt], filter: filter }"
              ></ng-container>
            </ISelectOption>
          }
        </ISelectContent>
      </IMultiSelectMenu>
    }
  </div>
</ng-container>

<ng-template #formatter let-value let-filter="filter">
  @switch (filter.type) {
    @case (FilterCategory.Marketplace) {
      <app-marketplace-formatter [values]="value" />
    }
    @case (FilterCategory.AccountType) {
      <app-account-type-formatter [values]="value" />
    }
    @case (FilterCategory.AccountGroup) {
      <app-string-formatter [values]="value" labelField="name" />
    }
    @case (FilterCategory.AccountBidderStatus) {
      <app-account-bidder-status-formatter [values]="value" class="[&_*]:!cursor-pointer" />
    }
    @case (FilterCategory.ProductGroup) {
      <app-string-formatter [values]="value" labelField="productGroupName" />
    }
    @case (FilterCategory.KeywordSegment) {
      <app-string-formatter [values]="value" labelField="name" />
    }
    @case (FilterCategory.ProductSegment) {
      <app-string-formatter [values]="value" labelField="name" />
    }
    @case (FilterCategory.BrandTraffic) {
      <app-string-formatter [values]="value" labelField="name" />
    }
    @case (FilterCategory.Strategy) {
      <app-strategy-formatter [values]="value" />
    }
    @case (FilterCategory.AdType) {
      <app-ad-type-formatter [values]="value" />
    }
    @case (FilterCategory.BrandProducts) {
      <app-string-formatter [values]="value" labelField="name" />
    }
    @case (FilterCategory.Brand) {
      <app-string-formatter [values]="value" labelField="brandName" />
    }
    @case (FilterCategory.DspCampaign) {
      <app-string-formatter [values]="value" labelField="name" />
    }
    @case (FilterCategory.DspCreative) {
      <app-string-formatter [values]="value" labelField="name" />
    }
    @case (FilterCategory.Bulk) {
      <app-string-formatter [values]="value" />
    }
    @case (FilterCategory.ProductTag1) {
      <app-string-formatter [values]="value" />
    }
    @case (FilterCategory.ProductTag2) {
      <app-string-formatter [values]="value" />
    }
    @case (FilterCategory.DspFunnel) {
      <app-string-formatter [values]="value" [translationKeys]="dspFunnelTranslationKeys" />
    }
    @case (FilterCategory.DspDealSource) {
      <app-string-formatter [values]="value" [translationKeys]="dspDealSourceTranslationKeys" />
    }
    @case (FilterCategory.DspDealType) {
      <app-string-formatter [values]="value" [translationKeys]="dspDealTypeTranslationKeys" />
    }
    @default {
      {{ value }}
    }
  }
</ng-template>
